// import { createSlice } from "@reduxjs/toolkit";
// import Cookies from "js-cookie";

// const initialState = {
//     userData: Cookies.get('userData') ? JSON.parse(Cookies.get('userData')) : null,
//     token: Cookies.get('token') ? Cookies.get('token') : null,
//     isAuthenticated: !!Cookies.get('token'),
// }

// export const user_information = createSlice({
//     name: "user",
//     initialState,
//     reducers: {
//         setUserData(state, action) {
//             state.userData = action.payload.userData;
//             state.token = action.payload.token;
//             state.isAuthenticated = true;
            
//             // Store in cookies
//             if (action.payload.rememberMe) {
//                 // Set with longer expiry for "Remember Me"
//                 Cookies.set('userData', JSON.stringify(action.payload.userData), { expires: 30 }); // 30 days
//                 Cookies.set('token', action.payload.token, { expires: 30 });
//             } else {
//                 // Session cookie (expires when browser closes)
//                 Cookies.set('userData', JSON.stringify(action.payload.userData));
//                 Cookies.set('token', action.payload.token);
//             }
//         },
        
//         logout(state) {
//             state.userData = null;
//             state.token = null;
//             state.isAuthenticated = false;
            
//             // Remove from cookies
//             Cookies.remove('userData');
//             Cookies.remove('token');
            
//             // Also clear localStorage
//             localStorage.removeItem('willowToken');
//             localStorage.removeItem('willowUser');
//             localStorage.removeItem('loginTime');
//             localStorage.removeItem('rememberedLoginId');
//             localStorage.removeItem('rememberedPassword');
//         },
        
//         updateUserData(state, action) {
//             if (state.userData) {
//                 state.userData = { ...state.userData, ...action.payload };
//                 Cookies.set('userData', JSON.stringify(state.userData));
//             }
//         },
        
//         // Optional: For silent login or token refresh
//         setToken(state, action) {
//             state.token = action.payload;
//             state.isAuthenticated = true;
//             Cookies.set('token', action.payload);
//         }
//     }
// });

// export const { setUserData, logout, updateUserData, setToken } = user_information.actions;
// export default user_information.reducer;

import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
    userData: Cookies.get('userData') ? JSON.parse(Cookies.get('userData')) : null,
    token: Cookies.get('token') ? Cookies.get('token') : null,
    isAuthenticated: !!Cookies.get('token'),
      hasSubmittedPayment: Cookies.get('hasSubmittedPayment') === 'true',
}

export const user_information = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserData(state, action) {
            const { userData, token, rememberMe } = action.payload;
            
            // Store all wallet information
            state.userData = {
                ...userData,
                wallets: {
                    main_wallet: userData.main_wallet || 0,
                    release_wallet: userData.release_wallet || 0,
                    current_wallet: userData.current_wallet || 0
                }
            };
            
            state.token = token;
            state.isAuthenticated = true;
            
            // Store in cookies
            if (rememberMe) {
                // Set with longer expiry for "Remember Me"
                Cookies.set('userData', JSON.stringify(state.userData), { expires: 30 }); // 30 days
                Cookies.set('token', token, { expires: 30 });
            } else {
                // Session cookie (expires when browser closes)
                Cookies.set('userData', JSON.stringify(state.userData));
                Cookies.set('token', token);
            }
        },
        
        updateWalletData(state, action) {
            if (state.userData && state.userData.wallets) {
                state.userData.wallets = {
                    ...state.userData.wallets,
                    ...action.payload
                };
                Cookies.set('userData', JSON.stringify(state.userData));
            }
        },
       // Update the logout reducer in your Redux slice
logout(state) {
  // This is just local state clearing
  state.userData = null;
  state.token = null;
  state.isAuthenticated = false;
  state.hasSubmittedPayment = false;
  
  // Remove from cookies
  Cookies.remove('userData');
  Cookies.remove('token');
  Cookies.remove('hasSubmittedPayment');
  
  // Also clear localStorage
  localStorage.removeItem('willowToken');
  localStorage.removeItem('willowUser');
  localStorage.removeItem('loginTime');
  localStorage.removeItem('rememberedLoginId');
  localStorage.removeItem('rememberedPassword');
  
  // Clear sessionStorage if used
  sessionStorage.clear();
},
        updateUserData(state, action) {
            if (state.userData) {
                state.userData = { ...state.userData, ...action.payload };
                Cookies.set('userData', JSON.stringify(state.userData));
            }
        },
        
        // Optional: For silent login or token refresh
        setToken(state, action) {
            state.token = action.payload;
            state.isAuthenticated = true;
            Cookies.set('token', action.payload);
        },
         // Add this new reducer for payment status
        setPaymentSubmitted(state, action) {
            state.hasSubmittedPayment = true;
            // Store in cookies for persistence
            Cookies.set('hasSubmittedPayment', 'true', { expires: 30 });
        },
        
        // Add this for active date
        setActiveDate(state, action) {
            if (state.userData) {
                state.userData.active_date = action.payload;
                // Update cookies
                Cookies.set('userData', JSON.stringify(state.userData));
            }
        },
        // Add this to check initial state
        checkPaymentStatus(state) {
            const hasSubmitted = Cookies.get('hasSubmittedPayment') === 'true';
            state.hasSubmittedPayment = hasSubmitted;
        },
    }
});

export const { setUserData, logout, updateUserData, setToken, updateWalletData,setActiveDate,checkPaymentStatus,setPaymentSubmitted } = user_information.actions;
export default user_information.reducer;